// extracted by mini-css-extract-plugin
export default {"inputContainer":"qNIH4","icon":"r6Lmw","selectedText":"BIia-","text":"uHJH7"};